import { createApp, configureCompat } from 'vue';
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/messages";
import "@/filters";
import "@/fontawesome";
import "@/directives";
import axios from "axios";
import VueAxios from "vue-axios";
import VueScrollTo from "vue-scrollto";
import ScrollLoader from "vue-scroll-loader";
import VueCookies from 'vue-cookies';
import VueGtm from '@gtm-support/vue-gtm'
import Clipboard from 'v-clipboard';
import BootstrapIcon from "./components/BootstrapIcon.vue"
import { VuePlausible } from 'vue-plausible';

import { CONFIG } from '@/config.js';
import { FILTERS } from './filters/index';
import { tooltip } from './directives/tooltip';
import VNetworkGraph from "v-network-graph";
import "v-network-graph/lib/style.css";

configureCompat({
    WATCH_ARRAY: 'suppress-warning',
    RENDER_FUNCTION: 'suppress-warning',
    INSTANCE_LISTENERS: 'suppress-warning',
    COMPONENT_FUNCTIONAL: 'suppress-warning',
    OPTIONS_BEFORE_DESTROY: 'suppress-warning',
    INSTANCE_SCOPED_SLOTS: 'suppress-warning',
    OPTIONS_DATA_MERGE: 'suppress-warning',
    // COMPONENT_V_MODEL: 'suppress-warning', // break multiselect
    CUSTOM_DIR: 'suppress-warning',
    INSTANCE_EVENT_EMITTER: 'suppress-warning',
    ATTR_FALSE_VALUE: 'suppress-warning',
    INSTANCE_ATTRS_CLASS_STYLE: 'suppress-warning',
    GLOBAL_PROTOTYPE: 'suppress-warning',
    GLOBAL_EXTEND: 'suppress-warning',
    GLOBAL_MOUNT: 'suppress-warning',
    OPTIONS_DESTROYED: 'suppress-warning',
    INSTANCE_DESTROY: 'suppress-warning',
});

const app = createApp(App);

app.directive('b-tooltip', tooltip)

if (CONFIG.gtmkey) {
    app.use(VueGtm, {
        id: CONFIG.gtmkey,
        vueRouter: router, // Pass the router instance to automatically sync with router (optional)
        enabled: !!CONFIG.gtmkey
    });
}

app.use(VueAxios, axios);
app.use(VueScrollTo, {
    container: "body",
    duration: 700,
    easing: "ease",
    offset: -80,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
});

app.use(ScrollLoader);
app.component('b-icon', BootstrapIcon)
app.use(VueCookies)
app.use(Clipboard);

app.use(VuePlausible, {
    domain: CONFIG.plausibleDomain,
    trackLocalhost: true,
    apiHost: CONFIG.plausibleTrackingApi
})

// this can be enabled when the next version of plausible will be rolled oout
// currently the outbound tracking disables _blank behaviour
//Vue.$plausible.enableAutoOutboundTracking()
app.$plausible.enableAutoPageviews()


app.use(router);
app.use(store);
app.use(i18n);
app.use(VNetworkGraph);

app.config.globalProperties.$filters = FILTERS

app.mount("#app");
